import React, { Component } from 'react';
import CategoryInFair from './CategoryInFair.jsx';
import './_ListCategoryInFair.scss';
import {Categories} from 'api';

class ListCategoryInFair extends Component {
  constructor() {
    super();
    this.state = {
      data: []
    }
  }

  componentDidMount() {
    Categories.actions.list.request().then(res => {
      if (res.data) {
        let data = res.data.filter(item => item.parentId !== null);
        this.setState({
          data
        })
      }
    })
  }

  render() {
    let { data } = this.state
    return (
      <div className='center'>
        <div className='list-category-of-fair'>
          {data.map(item => {
            return (
              <CategoryInFair {...item}/>
            )
          })}
        </div>
      </div>
    );
  }
}


export default ListCategoryInFair


// WEBPACK FOOTER //
// ./components/home/sub-view/ListCategoryInFair.jsx